/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check-circle': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.06.46a9.56 9.56 0 014.518 1.128.78.78 0 11-.735 1.376A8.04 8.04 0 1018.1 10.06a.78.78 0 111.56 0 9.6 9.6 0 11-9.6-9.6zm9.329 2.37a.722.722 0 01.076.932l-.076.09-8.879 8.878a.722.722 0 01-.93.076l-.09-.076L6.16 9.4a.721.721 0 01.931-1.096l.09.076L10 11.2l8.369-8.37a.721.721 0 011.02 0z" _fill="#1D3861"/>'
  }
})
